import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';
import { SearchLocationCompanyIdBase } from '../../../components/SearchLocationCompanyIdBase';
import { applyVehicleFilters, changeVehiclePropertyFilter, updateVehicleFilter } from '../actions';

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    reset(property) {
      dispatch(
        changeVehiclePropertyFilter(null, {
          reset: property,
        }),
      );
    },
    applyFilters() {
      dispatch(applyVehicleFilters());
    },
    changeValues(key, value, label = []) {
      dispatch(
        updateVehicleFilter({
          key: key,
          value: [value.toString().toLowerCase()],
          label: [label],
          type: 'single',
        }),
      );
    },
    change(value) {
      dispatch(
        changeVehiclePropertyFilter({
          key: 'location_company_id',
          value,
          type: 'single',
        }),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const SearchLocationCompanyId = compose(withConnect, withRouter, injectIntl)(SearchLocationCompanyIdBase);
